import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=dd11212a&scoped=true&lang=pug&"
import script from "./StudentList.vue?vue&type=script&lang=ts&"
export * from "./StudentList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=dd11212a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd11212a",
  null
  
)

export default component.exports